import { ColSize } from '@commutifi-fe/ui'
import { spacing } from 'constants/global'

declare type ColSpanType = number | string
interface ColLayout {
  xs?: ColSpanType | ColSize
  sm?: ColSpanType | ColSize
  md?: ColSpanType | ColSize
  lg?: ColSpanType | ColSize
  xl?: ColSpanType | ColSize
  xxl?: ColSpanType | ColSize
}

const createColLayouts = <ColLayoutType extends Record<string, ColLayout>>(sizes: ColLayoutType) => sizes
export const colLayouts = createColLayouts({
  'xs-12': { xs: 12 },
  'xs-24/sm-12': { xs: 24, sm: 12 },
  'xs-24/sm-12/md-8': { xs: 24, sm: 12, md: 8 },
  'xs-24/md-12/xl-8': { xs: 24, md: 12, xl: 8 },
  'xs-24/sm-12/md-8/lg-6': { xs: 24, sm: 12, md: 8, lg: 6 }
})

export const commonGutter: [number, number] = [
  parseInt('large' in spacing ? spacing.large : '24px'),
  parseInt('large' in spacing ? spacing.large : '24px')
]
